(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[338],{

/***/ 78507:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-schools",
      function () {
        return __webpack_require__(87543);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56168);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62044);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(27412);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46323);
/* harmony import */ var _enums_namespaces__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99731);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50744);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_translate_Trans__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46834);
/* harmony import */ var components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3245);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1984);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var helpers_jsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28808);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52662);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17651);
/* harmony import */ var context_langContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70082);

// @ts-ignore













var Schools = function(param) {
    var relatedGenre = param.relatedGenre, studentMonthlyPrice = param.studentMonthlyPrice, studentMonthlyPercentageDiscount = param.studentMonthlyPercentageDiscount, priceMonthly = param.priceMonthly, countryCode = param.countryCode;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_enums_namespaces__WEBPACK_IMPORTED_MODULE_4__/* .Namespace.Schools */ .l.Schools).t;
    var locale = (0,context_langContext__WEBPACK_IMPORTED_MODULE_12__/* .useLang */ .J)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_8___default()), {
                children: (0,helpers_jsx__WEBPACK_IMPORTED_MODULE_9__/* .basicSEO */ .F)(t("seo:for_schools_title"), t("seo:for_schools_description"))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().welcome), (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().register), (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().vouchersLanding), (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().forSchools)),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().registerWrapper),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().students)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().topLeft),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        children: t("forschools_title")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-center",
                                        children: t("forschools_description")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().btn), "btn", "btn-primary"),
                                        href: "mailto:skoly@dramox.cz",
                                        children: t("forschools_button")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().price),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "mb-0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_translate_Trans__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    i18nKey: "schools:forschools_obligatory",
                                    components: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            href: helpers__WEBPACK_IMPORTED_MODULE_11__/* .Permalink.genre */ .xm.genre(relatedGenre, locale),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {})
                                        }), 
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        children: t("forschools_price", {
                                            studentMonthly: studentMonthlyPrice
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: t("forschools_price_desc")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().tiles),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().tileCol),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().tile),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                children: t("forschools_student_price_title")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: t("forschools_student_price_desc", {
                                                    monthly: priceMonthly,
                                                    studentMonthly: studentMonthlyPrice,
                                                    studentMonthlyPercentageDiscount: studentMonthlyPercentageDiscount
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().tile),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().iconWrapper), (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().school)),
                                                children: "icon ticket"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                children: t("forschools_for_who_title")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    t("forschools_for_who_desc_1"),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_translate_Trans__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                        i18nKey: "schools:forschools_for_who_desc_2",
                                                        components: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "mailto:skoly@dramox.cz"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().tileCol),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().tile),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().iconWrapper), (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().dramox)),
                                            children: "icon ticket"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            children: t("forschools_for_class_title")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_translate_Trans__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                        i18nKey: "schools:forschools_for_class_desc_1",
                                                        components: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "mailto:skoly@dramox.cz"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    children: [
                                                        t("forschools_for_class_desc_2_1"),
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                        t("forschools_for_class_desc_2_2")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: t("forschools_for_class_desc_3")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: t("forschools_for_class_desc_4")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: t("forschools_for_class_desc_5")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().buySection),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: t("forschools_title")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: t("forschools_bottom_desc", {
                                    studentMonthly: studentMonthlyPrice
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().btn), "btn", "btn-primary"),
                                href: "mailto:skoly@dramox.cz",
                                children: t("forschools_button")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,context__WEBPACK_IMPORTED_MODULE_10__/* .withForcePlanToLoggedInUnsubs */ .DE)(Schools));


/***/ }),

/***/ 27412:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"forSchools":"for-schools_forSchools__qTsd3","registerWrapper":"for-schools_registerWrapper__O3hEm","students":"for-schools_students__pR6Jd","price":"for-schools_price___k0Qv","school":"for-schools_school__4orQV","dramox":"for-schools_dramox__Gecud","tiles":"for-schools_tiles__29IxH","tileCol":"for-schools_tileCol__kzKBP","tile":"for-schools_tile__oV4bE","vouchersLanding":"for-schools_vouchersLanding__cccuV","topLeft":"for-schools_topLeft__5lYe_","btn":"for-schools_btn__Kg2h6","offers":"for-schools_offers__6kUd0","pic":"for-schools_pic___GUb5","iconWrapper":"for-schools_iconWrapper__ePnZD","ticket":"for-schools_ticket__ZjydE","theater":"for-schools_theater__NRT6f","buySection":"for-schools_buySection__MUDf_","img":"for-schools_img__u5PKM"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(78507); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);